<template>
    <div class="c-app">
        <TheSidebar/>
        <CWrapper>
            <TheHeader/>
            <div class="c-body">
                <main class="c-main">
                    <CContainer fluid>
                        <transition name="fade">
                            <router-view></router-view>
                        </transition>
                    </CContainer>
                </main>
                <TheFooter/>
            </div>
        </CWrapper>
    </div>
</template>

<script>
    import TheSidebar from './TheAdminSidebar'
    import TheHeader from './TheAdminHeader'
    import TheFooter from './TheAdminFooter'

    export default {
        name: 'TheAdminContainer',
        components: {
            TheSidebar,
            TheHeader,
            TheFooter
        }
    }
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
